module.exports = __webpack_public_path__ + "static/img/li1_4.530c447b.png";